module.exports = __webpack_public_path__ + "img/elem1Image.8703a88c.png";